/* eslint-disable guard-for-in */
import 'isomorphic-fetch';
import { isEmpty } from 'lodash';
import URI from 'urijs';
import Cookies from 'js-cookie';

import requestTimeout from './request-timeout';
import Request from './request';
import * as Sentry from '@sentry/browser';
import moLogin, { toggleLogin } from '@store/login';

const abortController = new AbortController();
const { signal } = abortController;

const apiGet = (
  requestURL: string,
  params: any = null,
  second: number = 60000,
) => {
  const newURL = new URI(requestURL);
  // 拼接url参数
  if (!isEmpty(params)) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) newURL.addQuery(key, params[key]);
  }
  return Promise.race([
    requestTimeout(second),
    Request('get', newURL, signal),
  ]).then((response): Promise<null> => {
    // 返回格式 response.json(), .text(), .blob(), .formData(), .arrayBuffer()
    // @ts-ignore
    if (response.status === 200 || response.code === 0) return response.json();

    // setError(true);
    // setErrorText('网络错误');
    // @ts-ignore
    return response.json();

    // 接口请求超时，中断请求
    // abortController.abort();
    // throw 'timeout';
  }).then((data: any) => {
    // console.log('data -- ', data);
    if (data.code !== 0) {
      // 打出接口地址 + 返回码 + 提示，便于定位是哪个接口返回了非正常数据
      // eslint-disable-next-line no-console
      console.error(`[apiGet] 接口返回异常 GET ${newURL.toString()} code=${data.code} msg=${data.msg}`);
      if (data.code === 5) {
        // changeErrorTyppe();
        console.log('后台错误');
        Sentry.captureException(data.msg);
      }
      if (data.code === -5) {
        console.log('请登录');
        Cookies.remove('access_token');
        // localforage.clear().then(() => {});
        // toggleLogin(true);
      }
      if (data.code.toString()[0] === '4') {
        Cookies.remove('access_token');
        // localforage.clear().then(() => {});
        toggleLogin(true);
      }
      if (data.code === 2) {
        // changeErrorTyppe();
        Sentry.captureException(data.msg);
        console.log('后台逻辑错误');
      }
    }
    return data;
  }).catch(err => {
    // 错误处理：不再静默吞掉，打出接口地址 + 错误详情，便于定位请求/解析失败的接口
    // eslint-disable-next-line no-console
    console.error(`[apiGet] 接口请求或解析失败 GET ${newURL.toString()}：`, err);
    return null;
  }).finally(() => {
    // Maybe do something
    // console.log('--- done --- ');
  });
};

export default apiGet;
